import { Document } from '@react-pdf/renderer';
import React from 'react';
import ReceiptPdf from '../ReceiptPdf';
import ReleaseOrderPdf from '../ReleaseOrderPdf';

const EmailDownloadAttachment = (props) => {
    const { data, attachmentType ,isClassified} = props;

    const getAttachmentByType = (attachmentType) => {
        switch (attachmentType) {
            case "ReleaseOrder":
                return <ReleaseOrderPdf data={data} isClassified={isClassified}/>
            case "Receipt":
                return <ReceiptPdf data={data} />
        }
    }

    return (
        <Document>
            {getAttachmentByType(attachmentType)}
        </Document>
    );
}

export default EmailDownloadAttachment;